
import { defineComponent } from 'vue'
import AppHeader from '@/components/Header.vue'
import getCacheFaultBillInfo from '@/compositions/fault/device'

export default defineComponent({
  name: 'Fault-Devices',
  components: {
    AppHeader,
  },
  setup() {
    const { cacheFaultDevices } = getCacheFaultBillInfo()
    return {
      cacheFaultDevices,
    }
  },
})
